import React from 'react';
import I18n from 'i18n-js';

import { RCAlertBox } from '@reverbdotcom/commons/src/rc';
import { useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';
import experiments from '@reverbdotcom/commons/src/experiments';

import { DateRange, MAX_SELLER_INITIATED_REFUND } from './shop_refund_stats';

export interface IProps {
  dateRange: DateRange;
  count?: number;
}

export default function ShopRefundStatsAlert({
  dateRange,
  count,
}: IProps) {
  const isExpEnabled = useExpEnabled(experiments.SELLER_REFUND_FEE_POLICY);
  const [showAlert, setShowAlert] = React.useState(
    isExpEnabled &&
    dateRange === DateRange.currentMonth &&
    count &&
    count >= MAX_SELLER_INITIATED_REFUND,
  );

  const isAtRefundLimit = count === MAX_SELLER_INITIATED_REFUND;

  const alertText = () => {
    if (isAtRefundLimit) {
      return I18n.t('discovery.dashboard.refundStats.alert.atRefundLimit');
    }

    return I18n.t('discovery.dashboard.refundStats.alert.exceededRefundLimit', { max: MAX_SELLER_INITIATED_REFUND });
  };

  if (showAlert) {
    return (
      <div className="shop-refund-stats__alert">
        <RCAlertBox
          type="warning"
          onDismiss={isAtRefundLimit ? () => setShowAlert(false) : undefined}
          small
        >
          <span className="shop-refund-stats__alert__content">
            {alertText()}
          </span>
        </RCAlertBox>
      </div>
    );
  }

  return null;
}
